<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M3.20451 2.65H7.29539C7.58944 2.65 7.85 2.90079 7.85 3.23433V5.76556C7.85 6.09923 7.58941 6.35 7.29539 6.35H3.20451C2.91062 6.35 2.65 6.09926 2.65 5.76556V3.23433C2.65 2.90077 2.91059 2.65 3.20451 2.65Z"
      stroke="#D7DCE6"
      stroke-width="0.8"
    />
    <path
      d="M3.20451 8.65H7.29539C7.60775 8.65 7.85 8.8982 7.85 9.18756V14.8125C7.85 15.1018 7.60777 15.35 7.29539 15.35H3.20451C2.89225 15.35 2.65 15.1018 2.65 14.8125V9.18756C2.65 8.89817 2.89228 8.65 3.20451 8.65Z"
      stroke="#D7DCE6"
      stroke-width="0.8"
    />
    <path
      d="M10.7046 11.65H14.7955C15.0894 11.65 15.35 11.9007 15.35 12.2344V14.7657C15.35 15.0992 15.0894 15.35 14.7955 15.35H10.7046C10.4106 15.35 10.15 15.0992 10.15 14.7657V12.2344C10.15 11.9008 10.4106 11.65 10.7046 11.65Z"
      stroke="#D7DCE6"
      stroke-width="0.8"
    />
    <path
      d="M14.3955 2.65H14.7955C15.0724 2.65 15.35 2.90381 15.35 3.28121V9.46868C15.35 9.84622 15.0723 10.1 14.7955 10.1H10.7046C10.4276 10.1 10.15 9.84619 10.15 9.46868V3.28121C10.15 2.90384 10.4276 2.65 10.7046 2.65H14.3955Z"
      stroke="#D7DCE6"
      stroke-width="0.8"
    />
  </svg>
</template>

<script>
export default {
  name: 'DashboardIcon'
};
</script>

<style scoped>

</style>